var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['font-sans']},[_vm._l((_vm.rowsData),function(row,index){return [_c('div',{key:((row.icon) + "-" + (row.text)),ref:row.ref,refInFor:true,class:[
        // Always set `display` to `block` to avoid overrides
        'block',

        // This is the space between the hover box and the edge of the row
        'py-1',
        'px-2' ],attrs:{"data-cy":row.testId,"data-pw":row.testId}},[_c(row.href ? 'a' : 'div',{tag:"component",class:[
          'group',
          // Wanted to use the resets that's already on `<OzBaseButton>`, but can't use a `<button>` element here
          // because we use a `<button>` for the `rightIcon` and nested `<button>`s are invalid.
          'focus:outline-none',

          row.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',

          // TEXT COLORS
          row.rowStyle === _vm.RowStyle.Default && {
            'text-dark-text-100': _vm.darkMode === false,
            'text-light-text-100': _vm.darkMode === true,
            'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Disabled && {
            'text-dark-text-300': _vm.darkMode === false,
            'text-light-text-300': _vm.darkMode === true,
            'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Highlighted && {
            'text-grape-500': _vm.darkMode === false,
            'text-canary-500': _vm.darkMode === true,
            'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Primary && 'text-padlet-pink-500',
          row.rowStyle === _vm.RowStyle.Danger && 'text-danger-100',
          // SHAPE
          // Combined with the space outside the hover box, the row has 16px of x-padding.
          'p-2',
          // 44px - 2*4px (padding outside hover box) - 2*8px (padding outside hover box) = 20px
          _vm.sizePreset === _vm.SizePreset.H44px && 'min-h-[20px]',
          // 48px - 2*4px (padding outside hover box) - 2*8px (padding outside hover box) = 24px
          _vm.sizePreset === _vm.SizePreset.H48px && 'min-h-[24px]',

          // HIGHLIGHT STYLES
          !row.isDisabled && 'transition-colors',
          !row.isDisabled &&
            _vm.focusStyle === _vm.FocusStyle.Bubble100 && [
              // Hover box is rounded
              'rounded-lg',
              {
                'hover-hover:hover:bg-light-ui-100 hover-hover:dark:hover:bg-dark-ui-100': _vm.darkMode === 'auto',
                'hover-hover:hover:bg-light-ui-100': _vm.darkMode === false,
                'hover-hover:hover:bg-dark-ui-100': _vm.darkMode === true,
              },
              {
                'focus-visible:bg-light-ui-100 dark:focus-visible:bg-dark-ui-100': _vm.darkMode === 'auto',
                'focus-visible:bg-light-ui-100': _vm.darkMode === false,
                'focus-visible:bg-dark-ui-100': _vm.darkMode === true,
              },
              {
                'active:bg-light-ui-100 dark:active:bg-dark-ui-100': _vm.darkMode === 'auto',
                'active:bg-light-ui-100': _vm.darkMode === false,
                'active:bg-dark-ui-100': _vm.darkMode === true,
              } ],
          !row.isDisabled &&
            _vm.focusStyle === _vm.FocusStyle.Bubble200 && [
              // Hover box is rounded
              'rounded-lg',
              {
                'hover-hover:hover:bg-light-ui-200 hover-hover:dark:hover:bg-dark-ui-200': _vm.darkMode === 'auto',
                'hover-hover:hover:bg-light-ui-200': _vm.darkMode === false,
                'hover-hover:hover:bg-dark-ui-200': _vm.darkMode === true,
              },
              {
                'focus-visible:bg-light-ui-200 dark:focus-visible:bg-dark-ui-200': _vm.darkMode === 'auto',
                'focus-visible:bg-light-ui-200': _vm.darkMode === false,
                'focus-visible:bg-dark-ui-200': _vm.darkMode === true,
              },
              {
                'active:bg-light-ui-200 dark:active:bg-dark-ui-200': _vm.darkMode === 'auto',
                'active:bg-light-ui-200': _vm.darkMode === false,
                'active:bg-dark-ui-200': _vm.darkMode === true,
              } ],
          !row.isDisabled &&
            _vm.focusStyle === _vm.FocusStyle.HighlightText &&
            row.rowStyle === _vm.RowStyle.Default &&
            _vm.textHighlightStyles,

          // INTERNAL LAYOUT
          'flex',
          'items-center' ],attrs:{"tabindex":row.isDisabled ? -1 : 0,"disabled":row.isDisabled,"aria-disabled":row.isDisabled,"href":row.href || null,"rel":row.href && 'noopener nofollow'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)}]}},[(_vm.xLeftIconOrAvatar && row.icon)?_c('OzIcon',{class:[
            { 'me-3': _vm.sizePreset === _vm.SizePreset.H44px, 'me-4': _vm.sizePreset === _vm.SizePreset.H48px },
            !row.isDisabled &&
              [_vm.FocusStyle.Bubble100, _vm.FocusStyle.Bubble200].includes(_vm.focusStyle) &&
              row.rowStyle === _vm.RowStyle.Default &&
              _vm.textHighlightStyles ],attrs:{"name":row.icon,"size":_vm.iconSize}}):(_vm.xLeftIconOrAvatar && row.avatar)?_c('OzAvatar',{class:[
            {
              'me-3': _vm.sizePreset === _vm.SizePreset.H44px,
              'me-4': _vm.sizePreset === _vm.SizePreset.H48px,
            },
            row.avatarStyles || 'rounded-full' ],attrs:{"width":_vm.iconSize,"height":_vm.iconSize,"src":row.avatar,"alt-text-name":row.text}}):_vm._e(),_vm._v(" "),_c('div',{class:[
            row.textTruncated && 'truncate',
            'flex-1',
            row.textStyleClass || {
              'text-body-small': _vm.sizePreset === _vm.SizePreset.H44px,
              'text-body': _vm.sizePreset === _vm.SizePreset.H48px,
            } ],attrs:{"title":row.text}},[(row.htmlText)?_c('span',{domProps:{"innerHTML":_vm._s(row.htmlText)}}):_c('span',[_vm._v(_vm._s(row.text))])]),_vm._v(" "),(row.rightIcon && row.rightIconEventPayload)?_c('OzTextButton',{class:[
            // Ensure a large enough tap area
            'h-full',
            _vm.sizePreset === _vm.SizePreset.H44px && 'ps-3',
            _vm.sizePreset === _vm.SizePreset.H48px && 'ps-4',

            // Resets <button>
            'pe-0',
            'py-0',
            'focus:outline-none',

            // Centralize OzIcon
            'flex',
            'flex-col',
            'justify-center' ],attrs:{"data-cy":row.rightIconTestId,"color-scheme":_vm.OzTextButtonColorScheme.Secondary,"dark-mode":_vm.darkMode,"aria-label":row.rightIconAriaLabel},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectRightIcon($event, row)}},nativeOn:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.selectRightIcon($event, row)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.selectRightIcon($event, row)}]}},[_c('OzIcon',{attrs:{"name":row.rightIcon,"size":row.rightIconSize || _vm.iconSize}})],1):_vm._e(),_vm._v(" "),(row.rightIcon && !row.rightIconEventPayload)?_c('OzIcon',{class:[
            row.rightIconHighlighted && {
              'text-grape-500': _vm.darkMode === false,
              'text-canary-500': _vm.darkMode === true,
              'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
            },
            !row.isDisabled &&
              row.rowStyle === _vm.RowStyle.Default && {
                'text-dark-text-200': _vm.darkMode === false,
                'text-light-text-200': _vm.darkMode === true,
                'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
              },
            !row.isDisabled &&
              _vm.focusStyle === _vm.FocusStyle.HighlightText &&
              row.rowStyle === _vm.RowStyle.Default &&
              _vm.textHighlightStyles ],attrs:{"name":row.rightIcon,"size":row.rightIconSize || _vm.iconSize,"aria-label":row.rightIconAriaLabel}}):_vm._e()],1)],1),_vm._v(" "),(_vm.xLastRowDivider || index < _vm.rows.length - 1)?_c('OzDivider',{key:((row.icon) + "-" + (row.text) + "-divider"),class:[
        !_vm.xLeftIconOrAvatar && 'mx-4',
        // 16px (left of icon) + 16px (icon) + 10px (right of icon) = ms-10.5
        _vm.xLeftIconOrAvatar && _vm.sizePreset === _vm.SizePreset.H44px && 'ms-10.5 me-4',
        // 16px (left of icon) + 24px (icon) + 16px (right of icon) = ms-14
        _vm.xLeftIconOrAvatar && _vm.sizePreset === _vm.SizePreset.H48px && 'ms-14 me-4' ],attrs:{"color-scheme":_vm.OzDividerColorScheme.Solid,"dark-mode":_vm.darkMode}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }